// Southern Methodist University's majors (#2740). Read on 2026-10-01 from the
// official Southern Methodist University Catalog 2026-2027 (catalog.smu.edu),
// Programs list: every program the catalog lists as a bachelor's major,
// grouped by the school the catalog places it in, with the degree as the
// catalog writes it (the engineering degrees as BSCE, BSECE, BSEnvE and BSME).
// Left out: minors, certificates, specializations, concentrations, graduate
// programs, pre-majors and undeclared starting points, and the Accelerated
// Pathway versions of majors (bachelor's to master's tracks the catalog lists
// beside the major itself).
const majors = {
    "slug": "southern-methodist-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in SMU's official 2026-2027 catalog, grouped by the school that offers it. Minors, certificates, graduate programs and the accelerated bachelor's to master's pathways are left out.",
    "groups": [
        {
            "name": "Cox School of Business",
            "source": {
                "label": "SMU Catalog 2026-2027, Cox School of Business",
                "url": "https://catalog.smu.edu/schools/cox"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business Analytics and Supply Chain Management",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "General Business",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Real Estate",
                    "degree": "BBA"
                }
            ]
        },
        {
            "name": "Dedman College of Humanities & Sciences",
            "source": {
                "label": "SMU Catalog 2026-2027, Dedman College of Humanities & Sciences",
                "url": "https://catalog.smu.edu/schools/dedman"
            },
            "majors": [
                {
                    "name": "African/African-American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biophysical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Economics with Finance Applications",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "French Studies",
                    "degree": "BA"
                },
                {
                    "name": "Health and Society",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Human Rights",
                    "degree": "BA"
                },
                {
                    "name": "Individualized Studies in Liberal Arts",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Markets & Culture",
                    "degree": "BA"
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Medieval Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mexican-American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistical Science",
                    "degree": "BS"
                },
                {
                    "name": "World Languages: Arabic",
                    "degree": "BA"
                },
                {
                    "name": "World Languages: Chinese",
                    "degree": "BA"
                },
                {
                    "name": "World Languages: French",
                    "degree": "BA"
                },
                {
                    "name": "World Languages: German",
                    "degree": "BA"
                },
                {
                    "name": "World Languages: Italian",
                    "degree": "BA"
                },
                {
                    "name": "World Languages: Russian",
                    "degree": "BA"
                },
                {
                    "name": "World Languages: Spanish",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Lyle School of Engineering",
            "source": {
                "label": "SMU Catalog 2026-2027, Lyle School of Engineering",
                "url": "https://catalog.smu.edu/schools/lyle"
            },
            "majors": [
                {
                    "name": "Civil Engineering",
                    "degree": "BSCE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Electrical and Computer Engineering",
                    "degree": "BSECE"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSEnvE"
                },
                {
                    "name": "Management Science",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSME"
                }
            ]
        },
        {
            "name": "Meadows School of the Arts",
            "source": {
                "label": "SMU Catalog 2026-2027, Meadows School of the Arts",
                "url": "https://catalog.smu.edu/schools/meadows"
            },
            "majors": [
                {
                    "name": "Advertising",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Bassoon Performance",
                    "degree": "BM"
                },
                {
                    "name": "Cello Performance",
                    "degree": "BM"
                },
                {
                    "name": "Clarinet Performance",
                    "degree": "BM"
                },
                {
                    "name": "Corporate Communication and Public Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Creative Computing",
                    "degree": "BA"
                },
                {
                    "name": "Dance Performance",
                    "degree": "BFA"
                },
                {
                    "name": "Double Bass Performance",
                    "degree": "BM"
                },
                {
                    "name": "Euphonium Performance",
                    "degree": "BM"
                },
                {
                    "name": "Fashion Media",
                    "degree": "BA"
                },
                {
                    "name": "Film & Media Arts",
                    "degree": "BA"
                },
                {
                    "name": "Film & Media Arts",
                    "degree": "BFA"
                },
                {
                    "name": "Flute Performance",
                    "degree": "BM"
                },
                {
                    "name": "French Horn Performance",
                    "degree": "BM"
                },
                {
                    "name": "Game Development",
                    "degree": "BA"
                },
                {
                    "name": "Guitar Performance",
                    "degree": "BM"
                },
                {
                    "name": "Harp Performance",
                    "degree": "BM"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Composition",
                    "degree": "BM"
                },
                {
                    "name": "Music Education",
                    "degree": "BM"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BM"
                },
                {
                    "name": "Music, Culture, and Society",
                    "degree": "BA"
                },
                {
                    "name": "Oboe Performance",
                    "degree": "BM"
                },
                {
                    "name": "Organ Performance",
                    "degree": "BM"
                },
                {
                    "name": "Percussion Performance",
                    "degree": "BM"
                },
                {
                    "name": "Piano Performance",
                    "degree": "BM"
                },
                {
                    "name": "Public Relations and Strategic Communication",
                    "degree": "BA"
                },
                {
                    "name": "Saxophone Performance",
                    "degree": "BM"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Trombone Performance",
                    "degree": "BM"
                },
                {
                    "name": "Trumpet Performance",
                    "degree": "BM"
                },
                {
                    "name": "Tuba Performance",
                    "degree": "BM"
                },
                {
                    "name": "Viola Performance",
                    "degree": "BM"
                },
                {
                    "name": "Violin Performance",
                    "degree": "BM"
                },
                {
                    "name": "Voice Performance",
                    "degree": "BM"
                }
            ]
        },
        {
            "name": "Simmons School of Education & Human Development",
            "source": {
                "label": "SMU Catalog 2026-2027, Simmons School of Education & Human Development",
                "url": "https://catalog.smu.edu/schools/simmons"
            },
            "majors": [
                {
                    "name": "Applied Physiology and Health Management",
                    "degree": "BS"
                },
                {
                    "name": "Educational Studies",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Sport Performance Leadership",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
